import { getConsentString } from './onetrust';
/**
 * SmartX Sync Pixel Utility
 *
 * Generates and loads the SmartX sync pixel for user synchronization with the advertising ecosystem.
 * The pixel includes TCF consent string and cachebuster parameters.
 */

const SMARTX_PIXEL_BASE_URL = 'https://ad.sxp.smartclip.net/ads';

interface SmartXPixelParams {
    type: string;
    plc: string;
    sz: string;
    rnd: string;
    consent?: string;
}

/**
 * Generates a cachebuster value (random number)
 */
function generateCachebuster(): string {
    return Math.floor(Math.random() * 1000000).toString();
}

/**
 * Builds the SmartX pixel URL with all required parameters
 */
function buildSmartXPixelUrl(): string {
    const params: SmartXPixelParams = {
        type: 'dyn',
        plc: '106864',
        sz: '1x1',
        rnd: generateCachebuster(),
    };

    // Add consent parameter if available
    const consentString = getConsentString();
    if (consentString) {
        params.consent = consentString;
    }

    const url = new URL(SMARTX_PIXEL_BASE_URL);
    Object.entries(params).forEach(([key, value]) => {
        if (value) {
            url.searchParams.set(key, value);
        }
    });

    return url.toString();
}

/**
 * Loads the SmartX sync pixel
 * This function creates an image element to trigger the pixel request
 */
export function loadSmartXPixel(): void {
    const pixelUrl = buildSmartXPixelUrl();

    // Create an image element to load the pixel
    const img = new Image();
    img.src = pixelUrl;
    img.style.display = 'none';
    img.style.width = '1px';
    img.style.height = '1px';

    // Add to document to trigger the request
    document.body.appendChild(img);

    // Clean up after a short delay
    setTimeout(() => {
        if (document.body.contains(img)) {
            document.body.removeChild(img);
        }
    }, 1000);
}
